import React from "react";
import { Box, Paper, Typography, useTheme } from "@mui/material";

const ParameterCard = ({ id, name, description, dataType, virtual }) => {
  const theme = useTheme();
  return (
    <Paper
      id={id}
      sx={{
        p: "1rem 1.25rem",
        mb: "0.75rem",
        backgroundColor: theme.palette.background.alt,
        borderLeft: virtual
          ? `3px solid ${theme.palette.divider}`
          : `3px solid ${theme.palette.secondary.main}`,
      }}
    >
      <Box display="flex" alignItems="baseline" flexWrap="wrap" gap="0.4rem">
        <Typography variant="h5" fontWeight={700} color={theme.palette.text.primary}>
          {name}
        </Typography>
        <Typography variant="body2" color={theme.palette.text.secondary}>
          ({dataType})
        </Typography>
      </Box>
      <Typography variant="body1" color={theme.palette.text.secondary} sx={{ mt: "0.25rem" }}>
        {description}
      </Typography>
      {virtual && (
        <Typography
          variant="caption"
          color={theme.palette.secondary.main}
          sx={{ display: "block", mt: "0.4rem" }}
        >
          {virtual}
        </Typography>
      )}
    </Paper>
  );
};

export default ParameterCard;
